<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div>
  <profile-pds-p-heading
    id="emailRequestAndInsertHeadline"
    p-heading
    class="profile:mt-fluid-md profile:sm:mt-0"
    [tag]="'h4'"
    [size]="'medium'"
    [attr.tabindex]="'-1'"
    weight="bold"
  >
    {{ translations().requestAndInsertHeadline }}
  </profile-pds-p-heading>

  <profile-pds-p-text p-text>
    {{ translations().insertCodeText }}
  </profile-pds-p-text>

  <profile-pds-p-heading p-heading class="profile:mt-fluid-md" [tag]="'h4'" [size]="'medium'" weight="bold">
    <span dir="ltr">{{ email().email }}</span>
  </profile-pds-p-heading>

  <div class="profile:mt-fluid-md">
    <div>
      <profile-pds-p-pin-code
        p-pin-code
        [length]="5"
        [label]="translations().pinCodeLabel"
        [hideLabel]="true"
        (change)="validateConfirmationCode($event)"
        [loading]="confirmationCodeStatus() === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING"
        [disabled]="isDisabled()"
        [state]="messageState()"
        [message]="messages()[0]"
        #emailCode
      ></profile-pds-p-pin-code>
    </div>
  </div>

  <profile-pds-p-text p-text class="profile:mt-fluid-md">
    {{ translations().noCodeReceivedLabel }}

    <pidx-timer-label
      [timer]="waitingTime"
      [disabled]="resendDisabled()"
      [requestCodeTimerLabel]="translations().requestCodeAgainLabel"
      [waitingTimerLabelText]="translations().waitingTimerMessage"
      (clickedTimerEvent)="requestConfirmationCode()"
      [myprofileUiTrack]="{
        clickElementType: 'button',
        clickElementId: 'email_address',
        clickElementName: 'request_verification_code',
      }"
    ></pidx-timer-label>
  </profile-pds-p-text>

  <profile-pds-p-button
    [aria]="{ 'aria-label': translations().cancelButtonA11y, 'aria-haspopup': 'dialog' }"
    p-button
    variant="secondary"
    (click)="cancel()"
    icon="close"
    class="profile:mt-fluid-md"
    data-protractor-id="email-widget-verification-cancel-button"
    [myprofileUiTrack]="{
      clickElementType: 'button',
      clickElementId: 'email_address',
      clickElementName: 'cancel',
    }"
    >{{ translations().cancelButtonLabel }}</profile-pds-p-button
  >
</div>
